<div class="container">
    <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
        <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
        <div class="col-sm-6 col-md-6 col-xl-4 m-auto text-left">
            <div class="form-group row">
                <label class="col-sm-5 col-form-label font18 pr-0" style="padding-left: 60px;">Year</label>
                <div class="col-sm-7 mt-1">
                    <!-- <select (change)="getAge($event);" [(ngModel)]="age" class="dropdown-toggle form-control">
                        <option *ngFor="let year of years" value={{year}}>{{year}}</option>
                    </select> -->
                    <ng-select
                    [items]="years"
                    placeholder="Select"
                    [searchable]="false" [clearable]="false"
                    (change)="getAge(age);" [(ngModel)]="age">
                    </ng-select>
                </div>
            </div>
        </div>
        <button  *ngIf="showbutton"  class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase" [ngClass]="{'sectbtn': disablebutton}"(click)="next();">Next</button>
        <!-- <p class="text-success mt-3">{{questionObj.tip}}</p> -->

        <div class="mt-5">
            <div class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center">
                <img src="assets/images/flash.png" class="mb-1" />
                <p class="text-center tiphead">TIP OF THE DAY</p>
                <p class="text-center tipmes">{{questionObj.tip}}</p>
                <!-- <p class="text-center font-weight-bold">TIP OF THE DAY<br>
            <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
            </div>
        </div>
    </div>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
    <div class="d-flex h-100 row col-sm-12 pr-0">
        <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
            <img style="width:100%;" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto">
            <div class="arrow_box" >
                <h1 class="questionMob text-left">{{question}}</h1>
            </div>
        </div>
    </div>
    <div class="row col-12 m-auto">
        <div class="form-group col-12 px-0 d-flex flex-wrap">
                <label class="col-5 col-form-label text-right">Year</label>
            <div class="col-7 px-0 mt-1">
                <!-- <select (change)="getAge($event);" [(ngModel)]="age" class="dropdown-toggle form-control">
                    <option *ngFor="let year of years" value={{year}}>{{year}}</option>
                </select> -->
                <ng-select
                [items]="years"
                placeholder="Select"
                [searchable]="true" [clearable]="false"
                (change)="getAge(age);" [(ngModel)]="age" >
                </ng-select>
            </div>
        </div>
        <br />
    </div>
    <div style="width:97% !important; text-align: right;">
        <div *ngIf="user_bot" class="ash_box text-right mb-3 mr-3" >
            <h1 class="ansMob text-right">{{age}}</h1>
        </div>
    </div>
    <div class="col-12 m-auto">
        <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr">
            <img src="assets/images/flash.png" class="mb-1" style="margin-left:48%" />
            <p class="text-center tiphead">TIP OF THE DAY</p>
            <p class="text-center tipmes">{{questionObj.tip}}</p>
            <!-- <p class="text-center font-weight-bold">TIP OF THE DAY<br>
                <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
        </div>
    </div>
</div>
<!-- <div class="btm-process webview">
    <div class="text-center" *ngIf="!messagetype">
      <span><img src="assets/images/active13.png"></span>
      <h4 class="clr333 processtxt">15% Completed</h4>
    </div>
    <div class="text-center" *ngIf="messagetype">
        <span><img src="assets/images/active9.png"></span>
        <h5 class="clr333 processtxt">45% Completed</h5>
      </div>
  </div> -->